import { render, staticRenderFns } from "./ProtocolloUtentiEditComponent.vue?vue&type=template&id=c1adcc90"
import script from "./ProtocolloUtentiEditComponent.vue?vue&type=script&lang=js"
export * from "./ProtocolloUtentiEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports